<script setup>
import { useCategoriesStore } from "@/stores/categories";

const companiesStore = useCategoriesStore();
const server = process.env.VUE_APP_SERVER;

companiesStore.fetchCategories();
</script>

<template>
  <div class="footer-logos">
    <marquee
      class="logos-marquee"
      behavior="scroll"
      direction="left"
      scrollamount="5"
    >
      <div class="logos-container">
        <template v-for="(company, index) in companiesStore.companies">
          <div
            :key="index"
            v-if="company.logo"
            class="logo"
            :style="{ backgroundImage: 'url(' + server + company.logo + ')' }"
          ></div>
        </template>
      </div>
    </marquee>
  </div>
</template>

<style scoped lang="scss">
.footer-logos {
  background-color: #f8f9fa;
  padding: 4px 0;
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  right: 0;
  z-index: 32;
  height: 53px;
  overflow: hidden;
}

.logos-marquee {
  display: flex;
  align-items: center;
  white-space: nowrap; /* Asegura que los logos estén en una línea horizontal */
}

.logos-container {
  display: flex;
  align-items: center;
  gap: 20px; /* Espacio entre logos */
}

.logo {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  border: 1px solid #eee;
  box-shadow: 0px 0px 16px 2px #eee;
}
</style>
